import React, { Component } from 'react'
import { defineMessages, FormattedDate, FormattedMessage, injectIntl } from 'react-intl'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import GlobalHelper from "../../../../common/GlobalHelper.jsx"
import Icon from "../../../../common/icon/icon.component.jsx"
import SectionWrapper from "../../sectionwrapper.component.jsx";
import $ from 'jquery'
import InvoiceStatusBadge from "../../../../invoice/status.component.jsx";
import ProposalMergeFields from "../../../MergeFields.jsx";
import AddressComponentSSR from "../../../../customer/components/AddressComponentSSR";

const messages = defineMessages({
    "disable_pdf_message": {
        id: 'proposal.items.disable_pdf_message',
        defaultMessage: 'This button is disabled in the edit mode',
    }
})

class DocumentInfoContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            isSample: this.props.isSample || false,
            isPdf: this.props.isPdf || false,
            isDummy: this.props.isDummy || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () {
            },
            id: this.props.id || '',
            documentEmail: this.props.variables.seller.email || '',
            companyEmail: this.props.variables.company.organizationEmail || '',
            templateEmail: this.props.templateEmail || '',
            locationEmail: this.props.variables.company.email || '',
        }
        this.checkPdfReady = this.checkPdfReady.bind(this)
    }

    componentDidMount() {
        $('[data-toggle="tooltip"]').tooltip()
        this.getDocumentEmail()
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            variables: nextProps.variables || null,
            section: nextProps.section || null,
            isPdf: nextProps.isPdf || false,
            isDummy: nextProps.isDummy || false,
            id: nextProps.id || '',
        })
    }

    getDocumentEmail() {
        switch (this.state.section.attributes.content.displayedEmailType) {
            case 'template':
                return this.state.templateEmail
            case 'company':
                return this.state.companyEmail
            case 'location':
                return this.state.locationEmail
            case 'hide':
                return ''
            default:
                return this.state.variables.seller.email
        }
    }

    checkPdfReady() {
        AppContext.getApiClient().get('/proposals/' + this.state.variables.hash).then(res => {
            if (res.attributes.variables.document.pdfUri && res.attributes.variables.document.pdfUri !== this.state.variables.document.pdfUri) {
                this.setState({
                    variables: res.attributes.variables,
                })
            } else {
                setTimeout(this.checkPdfReady, 3000)
            }
        })
    }

    getDummyExpirationDate() {
        return new Date(new Date().getTime() + 86400000 * (AppContext.getAccount() ?
            (AppContext.getAccount().attributes.numberOfDaysBeforeQuoteExpiration || 14) : 14))
    }

    getCustomerCompanyName() {
        if (this.state.variables?.customer?.customerAccount?.attributes?.contactType !== "organizations") {
            return ""
        }
        if (this.state.variables.customer?.name !== "") {
            return this.state.variables.customer.name
        }
        return ""
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }
        let pdfDownloadButton = ''
        let pdfReGenerateButton = ''

        if (!this.state.isPdf && !this.state.editable && !this.state.isDummy) {
            pdfDownloadButton = <a
                className="btn btn-light btn-sm"
                href={this.state.variables.document.pdfUri}
                target="_blank"
            >
                <Icon value={"file-pdf"} />
                <FormattedMessage
                    id="proposal.items.open_pdf_btn"
                    defaultMessage="Open"
                />
            </a>
        } else if (!this.state.isPdf) {
            pdfDownloadButton = <button
                id={'pdfDownloadBtn'}
                type="button"
                className="btn btn-light btn-sm"
                data-placement="top"
                data-toggle="tooltip"
                title={this.props.intl.formatMessage(messages['disable_pdf_message'])}>
                <Icon value={"file-pdf"} />
                <FormattedMessage
                    id="proposal.items.open_pdf_btn"
                    defaultMessage="Open"
                />
            </button>
        }

        if (this.state.isSample) {
            pdfDownloadButton = ''
            pdfReGenerateButton = ''
        }

        let parentOrganizationName = ""
        if (this.state.variables.customerParentOrganization?.name && (this.state.section.attributes.content.showParentOrganization || this.state.section.attributes.content.onlyShowOrganization)) {
            parentOrganizationName = <p className="m-0">
                {this.state.variables.customerParentOrganization?.name}
            </p>
        }

        const optionalCustomerEmail = this.state.section.attributes.content.hideCustomerEmail ? '' :
            <p className="m-0 text-truncate">{this.state.variables.billTo.email}</p>

        return <SectionWrapper
            id={this.state.id}
            section={this.state.section}
            onEdit={this.state.onEdit}
            editable={this.state.editable}
            variables={this.state.variables}
        >
            {this.state.section.attributes.content.hideSection ? <h2 /> :
                <div className="col-12 text-left">
                    <div className="row">
                        <div className="col-sm-4 col-xs-12 mb-2">
                            <div className="d-flex w-100">
                                <div className="flex-grow-1  min-width-zero">
                                    <p className="m-0 text-nowrap">
                                        <strong>
                                            <FormattedMessage
                                                id="templates.header.from_label"
                                                defaultMessage="From"
                                            /> :</strong>
                                    </p>
                                    {this.state.section.attributes.content.showSellerCompanyName ? <p className="m-0">
                                        {this.state.variables.company.name}
                                    </p> : ''}
                                    {!this.state.section.attributes.content.hideSellerName ? <p className="m-0">
                                        {this.state.variables.seller.name}
                                    </p> : ''}
                                    <AddressComponentSSR value={this.state.variables.company.address}
                                        localeWithoutRegionCode={AppContext.getLocale().getLanguageWithoutRegionCode()} />                                <p className="m-0 text-truncate">
                                        <a href={'mailto:' + this.getDocumentEmail()}>{this.getDocumentEmail()}</a>
                                    </p>
                                    <p className="m-0">
                                        <a href={'tel:' + this.state.variables.company.phoneNumber}>
                                            {GlobalHelper.formatPhoneNumber(this.state.variables.company.phoneNumber, this.state.variables.company?.address?.countryCode)}
                                        </a>
                                    </p>
                                    {!this.state.section.attributes.content.showAccountTaxNumber && this.state.variables.company.taxNumber ?
                                        <p className={"mb-0"}>
                                            <FormattedMessage
                                                id="proposal.items.account_tax_number"
                                                defaultMessage="Tax #"
                                            />
                                            :&nbsp;
                                            {this.state.variables.company.taxNumber}
                                        </p> : ''}
                                </div>

                            </div >
                        </div >
                        {this.state.variables.customer?.contactId &&
                            <div className="col-sm-4 col-xs-12 border-left mb-2">
                                <div>
                                    <div className="d-flex w-100">
                                        <div className="flex-grow-1 min-width-zero">
                                            <p className="m-0 text-nowrap">
                                                <strong>
                                                    <FormattedMessage
                                                        id="templates.header.to_label"
                                                        defaultMessage="To"
                                                    /> :</strong>
                                            </p>
                                            {this.state.section.attributes.content.showCustomerCompanyName ? <p className="m-0">
                                                {this.getCustomerCompanyName()}
                                            </p> : ''
                                            }
                                            {parentOrganizationName}

                                            {!this.state.section.attributes.content.onlyShowOrganization
                                            || this.state.variables?.customer?.customerAccount?.attributes?.contactType === "organizations" ?
                                                <p className="m-0">
                                                    {this.state.variables.billTo.name}
                                                </p> : ''
                                            }
                                            <AddressComponentSSR value={this.state.variables.billTo.address}
                                                localeWithoutRegionCode={AppContext.getLocale().getLanguageWithoutRegionCode()} />
                                            {optionalCustomerEmail}
                                            <p className="m-0">{GlobalHelper.formatPhoneNumber(this.state.variables.billTo.phoneNumber, this.state.variables.billTo?.address?.countryCode)}</p>
                                            {!this.state.section.attributes.content.showContactTaxNumber &&
                                                this.state.variables.customer?.taxNumber || this.state.variables.customerParentOrganization?.taxNumber ?
                                                <p className={"mb-0"}>
                                                    <FormattedMessage
                                                        id="proposal.items.contact_tax_number"
                                                        defaultMessage="Tax #"
                                                    />
                                                    :&nbsp;
                                                    {this.state.variables.customer?.taxNumber || this.state.variables.customerParentOrganization?.taxNumber}
                                                </p> : ''}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }

                        {
                            this.state.section.attributes.content.showShippingContact ?
                                <div className="col-sm-4 col-xs-12 border-left mb-2">
                                    <p className={"mb-1"}>
                                        <p className="m-0 text-nowrap">
                                            <strong>
                                                <FormattedMessage
                                                    id="templates.header.ship_to_label"
                                                    defaultMessage="Ship To"
                                                /> :</strong>
                                        </p>
                                        {parentOrganizationName}
                                        {!this.state.section.attributes.content.onlyShowOrganization ?
                                            <p className="m-0 text-nowrap">
                                                {this.state.variables.shipTo.name}
                                            </p> : ''}
                                        <p className="m-0">
                                            <AddressComponentSSR value={this.state.variables.shipTo.address}
                                                localeWithoutRegionCode={AppContext.getLocale().getLanguageWithoutRegionCode()} />
                                        </p>
                                    </p>
                                </div> :


                                <div className="col-sm-4 col-xs-12 border-left  mb-2">
                                    {this.state.variables.document.type === 'invoice' &&
                                        this.state.variables.quote.orderReferenceIdentifier != "" && !this.state.section.attributes.content.hideOrderReference &&
                                        <>
                                            <strong>
                                                <FormattedMessage
                                                    id="proposal.items.order_reference_identifier"
                                                    defaultMessage="Order Reference #"
                                                />
                                            </strong>
                                            <span id={'orderReference'}>{this.state.variables.quote.orderReferenceIdentifier}</span>
                                        </>
                                    }
                                    {this.state.variables.document.reference ?
                                        <p className={"mb-0"}>
                                            <strong>
                                                {this.state.variables.document.type === 'quote' ? <FormattedMessage
                                                    id="proposal.items.quote_number"
                                                    defaultMessage="Quote #"
                                                /> : null}
                                                {this.state.variables.document.type === 'invoice' ? <FormattedMessage
                                                    id="proposal.items.invoice_number"
                                                    defaultMessage="Invoice #"
                                                /> : null}
                                                {this.state.variables.document.type === 'credit-memo' ? <FormattedMessage
                                                    id="proposal.items.credit_memo_number"
                                                    defaultMessage="Credit memo #"
                                                /> : null}
                                                {!['quote', 'invoice', 'credit-memo'].includes(this.state.variables.document.type) ?
                                                    <FormattedMessage
                                                        id="proposal.items.document_reference"
                                                        defaultMessage="Reference:"
                                                    /> : null}
                                            </strong> <span
                                                id={'documentReference'}>{this.state.variables.document.reference}</span>
                                        </p> : ''}
                                    {this.state.variables.document.type === 'contract' &&
                                        <strong>
                                            <FormattedMessage
                                                id="proposal.items.quote_number"
                                                defaultMessage="Quote #"
                                            /> <span id={'documentReference'}>{this.state.variables.quote.reference}</span>
                                        </strong>
                                    }
                                    {(this.state.variables.quote && this.state.variables.quote.poNumber) ?
                                        <p className={"mb-0"}>
                                            <strong>
                                                {['quote', 'invoice', 'packing-slip'].includes(this.state.variables.document.type) ?
                                                    <FormattedMessage
                                                        id="proposal.items.document_po_number"
                                                        defaultMessage="PO number:"
                                                    /> : null}
                                            </strong> {this.state.variables.quote.poNumber}
                                        </p> : ''}
                                    <p className={"mb-0"}>
                                        <strong>
                                            <FormattedMessage
                                                id="proposal.items.quote_date"
                                                defaultMessage="Date"
                                            />
                                            :&nbsp;
                                        </strong>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                            value={
                                                this.state.variables.document.date ?
                                                    new Date(this.state.variables.document.date) :
                                                    new Date()
                                            } />
                                    </p>

                                    {this.state.variables.document.type === 'quote' &&
                                        !this.state.section.attributes.content.hideExpirationDate &&
                                        (this.state.variables.quote.expirationDate || this.state.isDummy) &&
                                        <p className={"mb-0"}>
                                            <strong>
                                                <FormattedMessage
                                                    id="proposal.items.quote_expiration_date"
                                                    defaultMessage="Expiration Date"
                                                />
                                                :&nbsp;
                                            </strong>
                                            <FormattedDate
                                                year='numeric'
                                                month='long'
                                                day='numeric'
                                                timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                                value={
                                                    !this.state.isDummy ?
                                                        new Date(this.state.variables.quote.expirationDate) :
                                                        this.getDummyExpirationDate()
                                                } />
                                        </p>
                                    }

                                    {this.state.variables.document.paymentTerm ? <p className={"mb-0"}>
                                        <strong>
                                            <FormattedMessage
                                                id="proposal.items.payment_term"
                                                defaultMessage="Term"
                                            />
                                            :&nbsp;
                                        </strong>
                                        {this.state.variables.document.paymentTerm}
                                    </p> : ''}

                                    {!this.state.section.attributes.content.hideDueDate &&
                                        this.state.variables.document.dueDate ? <p className={"mb-0"}>
                                        <strong>
                                            <FormattedMessage
                                                id="proposal.items.due_date"
                                                defaultMessage="Due date"
                                            />
                                            :&nbsp;
                                        </strong>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                            value={new Date(this.state.variables.document.dueDate)} />
                                    </p> : ''}
                                    {this.state.variables.quote.customStatus ? <p className={"mb-0"}>
                                        <strong>
                                            <FormattedMessage
                                                id="proposal.items.status"
                                                defaultMessage="Status"
                                            />
                                            :&nbsp;
                                        </strong>
                                        <span
                                            className={'badge badge-' + (this.state.variables.quote.status === 'ordered' ? 'warning' : 'success')}>
                                            {this.state.variables.quote.customStatus}
                                        </span>
                                    </p> : ''}
                                    {this.state.variables.quote.voidedAt ? <p className={"mb-0"}>
                                        <strong>
                                            <FormattedMessage
                                                id="proposal.items.voided_on"
                                                defaultMessage="Voided on"
                                            />
                                            :&nbsp;
                                        </strong>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                            value={new Date(this.state.variables.quote.voidedAt)} />
                                    </p> : ''}
                                    {this.state.variables.quote.status === 'voided' ? <p className={"mb-0"}>
                                        <InvoiceStatusBadge status={this.state.variables.quote.status} />
                                    </p> : ''}
                                    <p className={'mb-0 mt-1'}>{pdfDownloadButton}</p>
                                    {pdfReGenerateButton ? <p className={'m-0'}>{pdfReGenerateButton}</p> : ''}
                                </div>
                        }
                    </div >
                    {
                        this.state.section.attributes.content.showShippingContact ? <div className="row">
                            <div className={"col-12 border-top pt-2"}>
                                <p className={"mb-0"}>
                                    <strong>
                                        <FormattedMessage
                                            id="proposal.items.quote_date"
                                            defaultMessage="Date"
                                        />
                                        :&nbsp;
                                    </strong>
                                    <FormattedDate
                                        year='numeric'
                                        month='long'
                                        day='numeric'
                                        timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                        value={
                                            this.state.variables.document.date ?
                                                new Date(this.state.variables.document.date) :
                                                new Date()
                                        } />
                                    {
                                        this.state.variables.document.type === 'quote' &&
                                        !this.state.section.attributes.content.hideExpirationDate &&
                                        (this.state.variables.document.expirationDate || this.state.isDummy) &&
                                        [
                                            <span> - </span>,
                                            <strong>
                                                <FormattedMessage
                                                    id="proposal.items.quote_expiration_date"
                                                    defaultMessage="Expiration Date"
                                                />
                                                :&nbsp;
                                            </strong>,
                                            <FormattedDate
                                                year='numeric'
                                                month='long'
                                                day='numeric'
                                                timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                                value={
                                                    !this.state.isDummy ?
                                                        new Date(this.state.variables.document.expirationDate) :
                                                        this.getDummyExpirationDate()
                                                } />
                                        ]
                                    }
                                </p>
                                <p className={"mb-0"}>
                                    <ul className={"list-inline mb-0"}>
                                        {this.state.variables.document.reference ?
                                            <li className="list-inline-item border-right pr-2">
                                                <strong>
                                                    <FormattedMessage
                                                        id="proposal.items.quote_reference"
                                                        defaultMessage="Reference"
                                                    />
                                                    :
                                                </strong> {this.state.variables.document.reference}
                                            </li> : null}
                                        {this.state.variables.document.type === 'invoice' &&
                                            this.state.variables.quote.orderReferenceIdentifier != "" &&
                                            !this.state.section.attributes.content.hideOrderReference &&
                                            <li className="list-inline-item border-right pr-2">
                                                <strong>
                                                    <FormattedMessage
                                                        id="proposal.items.order_number"
                                                        defaultMessage="Order Reference:"
                                                    /> <span id={'orderReference'}>{this.state.variables.quote.orderReferenceIdentifier}</span>
                                                </strong>
                                            </li>
                                        }
                                        {(this.state.variables.quote && this.state.variables.quote.poNumber) ?
                                            <li className="list-inline-item border-right pr-2">
                                                <strong>
                                                    {['quote', 'invoice', 'packing-slip'].includes(this.state.variables.document.type) ?
                                                        <FormattedMessage
                                                            id="proposal.items.document_po_number"
                                                            defaultMessage="PO number:"
                                                        /> : null}
                                                </strong> {this.state.variables.quote.poNumber}
                                            </li> : ''}
                                        {this.state.variables.document.paymentTerm &&
                                            <li className="list-inline-item border-right pr-2">
                                                <strong>
                                                    <FormattedMessage
                                                        id="proposal.items.payment_term"
                                                        defaultMessage="Term"
                                                    />
                                                    :&nbsp;
                                                </strong>
                                                {this.state.variables.document.paymentTerm}
                                            </li>}
                                        {!this.state.section.attributes.content.hideDueDate &&
                                            this.state.variables.document.dueDate ?
                                            <li className="list-inline-item border-right pr-2">
                                                <strong>
                                                    <FormattedMessage
                                                        id="proposal.items.due_date"
                                                        defaultMessage="Due date"
                                                    />
                                                    :&nbsp;
                                                </strong>
                                                <FormattedDate
                                                    year='numeric'
                                                    month='long'
                                                    day='numeric'
                                                    timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                                    value={new Date(this.state.variables.document.dueDate)} />
                                            </li> : ''}
                                        {this.state.variables.quote.voidedAt ?
                                            <li className="list-inline-item border-right pr-2">
                                                <strong>
                                                    <FormattedMessage
                                                        id="proposal.items.voided_on"
                                                        defaultMessage="Voided on"
                                                    />
                                                    :&nbsp;
                                                </strong>
                                                <FormattedDate
                                                    year='numeric'
                                                    month='long'
                                                    day='numeric'
                                                    timeZone={ProposalMergeFields.getTimeZone(this.state.variables)}
                                                    value={new Date(this.state.variables.quote.voidedAt)} />
                                            </li> : ''}
                                        {this.state.variables.quote.status === 'voided' ?
                                            <li className="list-inline-item border-right pr-2">
                                                <InvoiceStatusBadge status={this.state.variables.quote.status} />
                                            </li> : ''}
                                        <li className="list-inline-item">
                                            {pdfDownloadButton}
                                        </li>
                                        {pdfReGenerateButton ? <li className="list-inline-item">
                                            {pdfReGenerateButton}
                                        </li> : ''}
                                    </ul>
                                </p>

                            </div>
                        </div> : ''
                    }

                </div >
            }
        </SectionWrapper>
    }

}

export default injectIntl(DocumentInfoContentSection)





// WEBPACK FOOTER //
// ./src/template/sections/content/document-info/section.component.jsx